import { useState } from 'react';

import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useHotkeys } from 'react-hotkeys-hook';

const devToolsAtom = atom(false);

export const useToggleDevTools = () => {
  const setToggleDevTools = useSetAtom(devToolsAtom);
  useHotkeys('r+b+l', () => setToggleDevTools((p) => !p));
};

export const useDevtoolsShortcut = () => {
  const shouldToggleDevTools = useAtomValue(devToolsAtom);

  return { showDevtools: shouldToggleDevTools };
};

export const usePrlDevtoolsShortcut = () => {
  const [isToggleDevTools, setToggleDevTools] = useState(false);

  useHotkeys('p+r+l', () => setToggleDevTools((p) => !p));

  return { showPrlDevtools: isToggleDevTools };
};
